import { XIcon } from "@heroicons/react/outline";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import SlotTime from "../SlotTime";

type BookedSlotProps = {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
};
export default function BookedSlot({ slot, onClick }: BookedSlotProps) {
  return (
    <div className="p-2 flex flex-col gap-6 w-full m-1 overflow-auto rounded-[4px] bg-brandblue-400">
      <button
        type="button"
        className="focus:outline-none w-fit self-end"
        onClick={() => onClick(slot)}
      >
        <XIcon className="w-4 h-4 text-white" />
      </button>
      <div className="self-center w-fit flex items-center gap-[1ch] flex-wrap text-white text-xs font-medium">
        <SlotTime time={slot.startTime} />
        -
        <SlotTime time={slot.endTime} />
      </div>
    </div>
  );
}
